import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { filter } from "rxjs/operators";

@Injectable()
export class ExternalRouterService{
    private _url:Array<any>=[];
    constructor(private router:Router, private cookieService:CookieService){
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd)
          ).subscribe((event: NavigationEnd) => {
            this._url.push(event.url)
            if(this._url.length == 1){
                let cachedLandingUrl = this.cookieService.get("url");
                if(cachedLandingUrl.length != 0){
                    this.cookieService.set("url", cachedLandingUrl + ","+this._url.join(","),null, "/")
                }
                else{
                    this.cookieService.set("url", this._url.join(","), null,"/")
                }
            }
        //    console.log(JSON.stringify(this._url))
          });
    }
    ngOnInit(){
    }
    getUrl():Array<any>{
        return this._url;
    }
}